import React from "react";
import cx from "classnames";

import { Link } from "react-router-dom";
import { Row, Col, OverlayTrigger, Tooltip, Image } from "react-bootstrap";
import dateformat from "dateformat";
import PageAnalyticsRowView from "../../../components/Analytics/Page/PageAnalyticsRowView";
import VideoAnalyticsGrapRowView from "../../../components/Analytics/Video/VideoAnalyticsGraphRowView.jsx";
import AudioAnalyticsGraphRowView from "../../../components/Analytics/Audio/AudioAnalyticsGraphRowView.jsx";
import VideoAnalyticsSegmentRowView from "../../../components/Analytics/Video/VideoAnalyticsSegmentRowView.jsx";
import AudioAnalyticsSegmentRowView from "../../../components/Analytics/Audio/AudioAnalyticsSegmentRowView.jsx";
import { FileService } from "src/services/file.service";

import styles from "./styles.module.scss";
import AssetDefaultIcon from "src/legacy/images/defaultAsset.jpg";
import PlayButton from "../../PlayButton";
import { localizedStrings } from "src/localization/index.jsx";
import Text from "src/components/text";

class ContactAssetShareView extends React.Component {
  constructor(props) {
    super(props);

    var hasAnalytics = false;
    if (FileService.hasAnalytics(this.props.asset.metadata)) {
      hasAnalytics = true;
    }

    this.state = {
      pages: [],
      pageCount: 0,
      hasAnalytics: hasAnalytics,
      loadingAnalytics: false,
      fetchedAnalytics: false,
      activePage: null,
      chart: {
        width: 250,
        visible: false,
      },
    };

    // localized contents
    this.localizedKeywords = localizedStrings.keywords;
    this.localizedCommons = localizedStrings.commons;
    this.localizedLoading = this.localizedCommons.loading;
    this.localizedCommonsActions = this.localizedCommons.actions;
    this.localizedContacts = this.localizedCommons.sliders.contacts;
  }

  componentDidMount() {
    if (
      this.props.shouldFetchAnalytics &&
      this.state.hasAnalytics &&
      this.props.asset.analytics.fetch &&
      !this.state.fetchedAnalytics
    ) {
      this.props.fetchAssetAnalytics(this.props.sectionId, this.props.asset);

      this.setState({
        fetchedAnalytics: true,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.shouldFetchAnalytics &&
      this.state.hasAnalytics &&
      nextProps.asset.analytics &&
      nextProps.asset.analytics.fetch &&
      !this.state.fetchedAnalytics
    ) {
      this.props.fetchAssetAnalytics(nextProps.sectionId, nextProps.asset);

      this.setState({
        fetchedAnalytics: true,
      });
    }

    if (
      nextProps.asset.analytics &&
      nextProps.asset.analytics.loading != this.props.asset.analytics.loading
    ) {
      this.setState({
        loadingAnalytics: nextProps.asset.analytics.loading,
      });
    }
  }

  render() {
    var assetViewEvent = null;
    var downloadViewEvent = null;

    const timeSpent = this.props.asset.totalTimeSpent || 0;
    let timeSpentValue = `~${this.padNumber(timeSpent, 1)}s`;

    if (timeSpent >= 60) {
      timeSpentValue = `~${this.padNumber(Math.round(timeSpent / 60), 1)}m`;
    }

    if (this.props.events) {
      this.props.events
        .filter((event) => {
          return event.exclusion === false;
        })
        .forEach((event) => {
          switch (event.type) {
            case "asset_viewed":
              assetViewEvent = event;
              break;
            case "asset_download":
              downloadViewEvent = event;
              break;

            default:
              break;
          }
        });
    }

    return (
      <Row className={cx(styles.asset, this.props.className)}>
        <Col md={6} className={styles.noPadding}>
          <Link
            to={`/assets/${this.props.asset.id}`}
            className={styles.assetLink}
          >
            {/* <Media> */}
            {/* <Media.Left align="bottom"> */}
            <Row className={styles.assetRow}>
              <Col xl={2} className={styles.noPadding}>
                <div className={styles.iconContainer}>
                  {this.props.asset.metadata && (
                    <PlayButton
                      asset={this.props.asset}
                      className={styles.playButton}
                      size={35}
                    />
                  )}
                  <Image className={styles.icon} src={this.renderAssetIcon()} />
                </div>
              </Col>
              <Col xl={10}>
              <div style={{marginLeft:10}}>
                  <h5 className={styles.name}>
                    <Text text={this.props.asset.name} />
                  </h5>
                <div className={cx(styles.assetMetrics, styles.noPadding)}>
                
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id="tooltip">
                          {assetViewEvent
                            ? `${this.localizedContacts.tooltip.last_viewed_on} ${dateformat(assetViewEvent.createdDate, "dd mmm yyyy")}`
                            : this.localizedContacts.tooltip.not_viewed}
                        </Tooltip>
                      }
                    >
                      <div className={styles.metrics}>
                        <span className="paperflite-eye"></span>
                        <label>
                          {assetViewEvent ? assetViewEvent.count : 0}
                        </label>
                      </div>
                    </OverlayTrigger>

                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id="tooltip">
                          {downloadViewEvent
                            ? `${this.localizedContacts.tooltip.last_downloaded_on} ${dateformat(downloadViewEvent.createdDate, "dd mmm yyyy")}`
                            : this.localizedContacts.tooltip.not_downloaded}
                        </Tooltip>
                      }
                    >
                      <div className={styles.metrics}>
                        <span className="paperflite-download"></span>
                        <label>
                          {downloadViewEvent ? downloadViewEvent.count : 0}
                        </label>
                      </div>
                    </OverlayTrigger>

                    <div className={styles.metrics}>
                      <span className="paperflite-clock"></span>
                      <label>{timeSpentValue}</label>
                    </div>
                </div>
              </div>
              </Col>
            </Row>
          </Link>
        </Col>
        <Col md={6} className={styles.chartAnalytics}>
          {this.state.hasAnalytics &&
            !this.state.loadingAnalytics &&
            assetViewEvent &&
            this.renderAnalytics(assetViewEvent)}

          {this.state.hasAnalytics && this.state.loadingAnalytics && (
            <div className={styles.loadingMessage}>
              {this.localizedLoading.analytics}...
            </div>
          )}

          {this.state.hasAnalytics &&
            !this.state.loadingAnalytics &&
            !assetViewEvent && (
              <div className={styles.emptyMessage}>
                {this.localizedCommons.no_activity}
              </div>
            )}

          {!this.state.hasAnalytics && assetViewEvent && (
            <div className={styles.emptyMessage}>
              {this.localizedContacts.tooltip.last_viewed}{" "}
              {dateformat(assetViewEvent.createdDate, "dd mmm yyyy")}
            </div>
          )}
        </Col>
      </Row>
    );
  }

  renderAssetIcon() {
    var icon = AssetDefaultIcon;
    if (this.props.asset.icon) {
      icon = this.props.asset.icon.thumbnail;
    }

    return icon;
  }

  renderAnalytics(event) {
    var analytics =
      this.props.asset.analytics && this.props.asset.analytics.item;

    if (!analytics) {
      return false;
    }

    if (analytics.type === "PAGE_ANALYTICS") {
      return (
        <PageAnalyticsRowView
          className={styles.pageMetrics}
          asset={this.props.asset}
          analytics={analytics}
          lastViewedDate={event.createdDate}
          preview={this.props.asset.preview}
          renderWithin="contact"
        />
      );
    } else if (analytics.type === "VIDEO_ANALYTICS") {
      if (this.props.renderWithin === "conversation") {
        return (
          <VideoAnalyticsGrapRowView
            className={styles.pageMetrics}
            asset={this.props.asset}
            analytics={analytics}
            lastViewedDate={event.createdDate}
          />
        );
      } else if (this.props.renderWithin === "contact") {
        return (
          <VideoAnalyticsSegmentRowView
            className={styles.pageMetrics}
            asset={this.props.asset}
            analytics={analytics}
            lastViewedDate={event.createdDate}
          />
        );
      }
    } else if (analytics.type === "AUDIO_ANALYTICS") {
      if (this.props.renderWithin === "contact") {
        return (
          <AudioAnalyticsSegmentRowView
            className={styles.pageMetrics}
            asset={this.props.asset}
            analytics={analytics}
            lastViewedDate={event.createdDate}
          />
        );
      } else if (this.props.renderWithin === "conversation") {
        return (
          <AudioAnalyticsGraphRowView
            className={styles.pageMetrics}
            asset={this.props.asset}
            analytics={analytics}
            lastViewedDate={event.createdDate}
          />
        );
      }
    }

    return false;
  }

  padNumber(number = 0, pad) {
    number = Math.ceil(number);

    const length = pad - String(number).length + 1;
    let padding = "";
    if (length > 0) {
      padding = Array(pad - String(number).length + 1).join("0");
    }

    return padding + number;
  }

  timeSpentValue(timeSpent) {
    let timeSpentValue = `~${this.padNumber(timeSpent, 1)}s`;

    if (timeSpent >= 60) {
      timeSpentValue = `~${this.padNumber(Math.round(timeSpent / 60), 1)}m`;
    }

    return timeSpentValue;
  }
}

export default ContactAssetShareView;
